/* global axios */
import ApiClient from './ApiClient';

class WhatsappStickersAPI extends ApiClient {
  constructor() {
    super('whatsapp_stickers', { accountScoped: true });
  }

  createSticker({ file, name, favorite = false }) {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);
    formData.append('favorite', favorite);
    return axios.post(this.url, formData);
  }

  saveFromAttachment({ attachmentId, name, favorite = true }) {
    return axios.post(`${this.url}/from_attachment`, {
      attachment_id: attachmentId,
      name,
      favorite,
    });
  }

  stats() {
    return axios.get(`${this.url}/stats`);
  }
}

export default new WhatsappStickersAPI();
